import type { Theme } from '@vfuk/core-themes'

import type { SimpleSkeletonLoaderTheme } from './SimpleSkeletonLoader.theme.types'

const defaultTheme = (theme: Theme): SimpleSkeletonLoaderTheme => {
  return {
    appearance: {
      primary: {
        backgroundColor: '#EBEBEB',
        accentColor: 'linear-gradient(90deg, rgba(235, 235, 235, 0) 0%, rgba(75, 75, 75, 0.6) 49.48%, rgba(235, 235, 235, 0) 100%);',
        inverse: {
          backgroundColor: theme.inverseColor.opacity2.default,
          accentColor: 'linear-gradient(90deg, rgba(235, 235, 235, 0) 0%, rgba(255, 255, 255, 0.6) 49.48%, rgba(235, 235, 235, 0) 100%)',
        },
      },
    },
  }
}

export default defaultTheme
